import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

import {
  SET_BLOCK,
  SET_TIP_POPUP_SHOW_STATUS,
  SET_BAG_POPUP_SHOW_STATUS,
  SET_RULE_POPUP_SHOW_STATUS,
  UPDATE_LOGIN_STATUS,
  UPDATE_CREATE_STATE,
  UPDATE_BIND_STATE,
  UPDATE_INVITE_NUM,
  UPDATE_INVITE_PAY_TOTAL,
  UPDATE_INVITE_LIST,
  UPDATE_NEED_STATE,
  UPDATE_AWARD_LOG,
  UPDATE_MYPAY_INFO,
  UPDATE_ONE_STATUS,
  UPDATE_TWO_STATUS,
  BIND_CODE,
  CREATE_CODE,
  LOAD_EVENT_BASIC,
  GET_AWARD,
  GET_AWARD_LOG,
  EVENT_IS_LOGIN
} from '@store/officialStore/event'

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      isLogin: state => state.event.isLogin,
      curLanguage: state => state.event.curLanguage,
      isShowEventTipPopup: state => state.event.isShowEventTipPopup,
      isShowBagPopup: state => state.event.isShowBagPopup,
      isShowRulePopup: state => state.event.isShowRulePopup,
      isNeedAward: state => state.event.isNeedAward,
      isBindCode: state => state.event.isBindCode,
      isCreateCode: state => state.event.isCreateCode,
      invitationCode: state => state.event.invitationCode,
      invitationLink: state => state.event.invitationLink,
      bindInvitationCode: state => state.event.bindInvitationCode,
      myPay: state => state.event.myPay,
      inviteNum: state => state.event.inviteNum,
      invitePayTotal: state => state.event.invitePayTotal,
      inviteList: state => state.event.inviteList,
      awardLog: state => state.event.awardLog,
      myPayInfo: state => state.event.myPayInfo,
      isComplete1: state => state.event.isComplete1,
      isComplete2: state => state.event.isComplete2,
      block: state => state.event.block
    }),
    ...mapGetters([
    ]),
  },
  methods: {
    ...mapMutations({
      setBlock: SET_BLOCK,
      setTipPopupShowStatus: SET_TIP_POPUP_SHOW_STATUS,
      setBagPopupShowStatus: SET_BAG_POPUP_SHOW_STATUS,
      setRulePopupShowStatus: SET_RULE_POPUP_SHOW_STATUS,
      updateLoginStatus: UPDATE_LOGIN_STATUS,
      updateCreateState: UPDATE_CREATE_STATE,
      updateBindState: UPDATE_BIND_STATE,
      updateInviteNum: UPDATE_INVITE_NUM,
      updateInvitePayTotal: UPDATE_INVITE_PAY_TOTAL,
      updateInviteList: UPDATE_INVITE_LIST,
      updateNeedState: UPDATE_NEED_STATE,
      updateAwardLog: UPDATE_AWARD_LOG,
      updateMypayInfo: UPDATE_MYPAY_INFO,
      updateOneStatus: UPDATE_ONE_STATUS,
      updateTwoStatus: UPDATE_TWO_STATUS,
    }),
    ...mapActions({
      bindCode: BIND_CODE,
      createCode: CREATE_CODE,
      loadEventBasic: LOAD_EVENT_BASIC,
      getAward: GET_AWARD,
      getAwardLog: GET_AWARD_LOG,
      eventIsLogin: EVENT_IS_LOGIN,
    }),
    hideEventTipPopup() {
      this.setTipPopupShowStatus(false)
    },
    showEventTipPopup() {
      this.setTipPopupShowStatus(true)
    },
    hideBagPopup() {
      this.setBagPopupShowStatus(false)
    },
    showBagPopup() {
      this.setBagPopupShowStatus(true)
    },
    hideRulePopup() {
      this.setRulePopupShowStatus(false)
    },
    showRulePopup() {
      this.setRulePopupShowStatus(true)
    },
    bindInviteCode(bindCode) {
      this.bindCode(bindCode)
    }
  }
}
